import { Box, Collapse, IconButton, Typography } from "@mui/material";
import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const CollapsibleSection = ({
  idx,
  title,
  field,
  handleClose,
  children,
  expanded,
  onToggle,
}) => {
  const handleIconClick = (event) => {
    event.stopPropagation(); // Prevents the click from bubbling up to the Box element
    onToggle();
  };

  return (
    <>
      <Box
        mb={2}
        onClick={onToggle}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 2,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
          }}
        >
          {idx + 1}. {title}
        </Typography>
        <IconButton sx={{ fontWeight: "600" }} onClick={handleIconClick}>
          <ArrowDropDownIcon
            style={{
              fontWeight: "bold",
              color: "black",
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          />
        </IconButton>
      </Box>
      <Collapse in={expanded}>{children}</Collapse>
    </>
  );
};

export default CollapsibleSection;